import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Modal, ModalBody } from "reactstrap";
import AccountCreation from './AccountCreation';
import PndApi from '../../../../../utils/pnd/PndRestApi';
import { showNotification, successNofication } from "src/shared/components/Notification";
import { Redirect } from 'react-router-dom';
import { ERROR_MESSAGES, PAGE_TIMEOUT } from "src/utils/pnd/PndConstants";
import CloseIcon from '@mui/icons-material/Close';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { CircularProgress } from '@mui/material';

const ModalUserCreationForm = ({ modalShow, setModalShow, isTitle, userData }) => {
    const [isRedirect, setIsRedirect] = useState(false);
    const [loading, setLoading] = useState(false);

    if (isRedirect) {
        window.location.reload();
    }

    const toggle = () => {
        if (!loading) {
            setModalShow(prevState => !prevState);
        }
    }

    const handleSubmit = async (formValues) => {
        try {
            setLoading(true);
            if (!(formValues.userId && formValues.userId > 0)) {
                const uppercaseRegExp = /(?=.*?[A-Z])/;
                const lowercaseRegExp = /(?=.*?[a-z])/;
                const digitsRegExp = /(?=.*?[0-9])/;
                const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/;
                const minLengthRegExp = /.{8,}/;
                const uppercasePassword = uppercaseRegExp.test(formValues["password"]);
                const lowercasePassword = lowercaseRegExp.test(formValues["password"]);
                const digitsPassword = digitsRegExp.test(formValues["password"]);
                const specialCharPassword = specialCharRegExp.test(formValues["password"]);
                const minLengthPassword = minLengthRegExp.test(formValues["password"]);
                if (!uppercasePassword || !lowercasePassword || !digitsPassword || !specialCharPassword || !minLengthPassword) {
                    showNotification(
                        "theme-light",
                        "ltr",
                        `SuccessCode: 500`,
                        `Message: Password must include at least one lowercase letter, one uppercase letter, one special character, one digit and must be at least 8 characters long.`,
                    );
                    setLoading(false);
                    return;
                }
            }

            if (formValues["password"] !== formValues["confirmPassword"]) {
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: 500`,
                    `Message: Password is not Matched`,
                );
                setLoading(false);
                return;
            }
            let obj = {};
            if (formValues["active"]) {
                obj["active"] = 1;
            } else {
                obj["active"] = 0;
            }
            if (formValues["roleId"]["value"]) {
                obj["roleId"] = formValues["roleId"]["value"];
            } else {
                obj["roleId"] = 1;
            }
            if (typeof formValues["customerId"] !== 'undefined')
                obj["customerId"] = formValues["customerId"]["value"];
            else {
                if (localStorage.getItem("ci") != null) {
                    obj["customerId"] = localStorage.getItem("ci");
                } else {
                    obj["customerId"] = null;
                }
            }
            obj["fullName"] = formValues["fullName"];
            obj["emailId"] = formValues["emailId"];
            if (formValues.userId !== 'undefined' || formValues.userId != null) {
                obj["password"] = formValues["password"]
                obj["userId"] = formValues["userId"];
            }
            obj["userName"] = formValues["userName"];
            obj["mobileNo"] = formValues["mobileNo"];
            obj["phoneNo"] = formValues["phoneNo"];
            if (typeof formValues["hub"] !== 'undefined')
                obj["hubId"] = formValues["hub"]["value"];
            else {
                formValues["hubId"] = null;
            }
            const response = await PndApi.AddOrUpdateUserDetails(obj);
            if (response.status === 200 && response.data.status === 200) {
                successNofication(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    ERROR_MESSAGES.successMessage,
                );
                setTimeout(() => {
                    setIsRedirect(true);
                }, PAGE_TIMEOUT);
            } else {
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    `Message:${response.data.message}`,
                );
            }
        } catch (error) {
            showNotification(
                "theme-light",
                "ltr",
                `SuccessCode: 500`,
                ERROR_MESSAGES.tryCatchError,
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Modal
                isOpen={modalShow}
                toggle={toggle}
                modalClassName="ltr-support"
                className="theme-light ltr-support"
                size="lg"
                backdrop={loading ? "static" : true}
                style={{ maxWidth: '900px' }}
            >
                {/* Modern Modal Header */}
                <div
                    className="position-relative"
                    style={{
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        padding: '1.5rem 2rem',
                        borderRadius: '0.5rem 0.5rem 0 0',
                        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                    }}
                >
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                            <div
                                className="d-flex align-items-center justify-content-center me-3"
                                style={{
                                    width: '48px',
                                    height: '48px',
                                    background: 'rgba(255,255,255,0.2)',
                                    borderRadius: '12px',
                                    backdropFilter: 'blur(10px)'
                                }}
                            >
                                <PersonAddIcon style={{ fontSize: '28px', color: '#fff' }} />
                            </div>
                            <div>
                                <h4
                                    className="m-0 text-white fw-bold"
                                    style={{
                                        fontSize: '1.5rem',
                                        letterSpacing: '0.5px',
                                        textShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                    }}
                                >
                                    {isTitle}
                                </h4>
                                <p className="m-0 text-white-50 small">
                                    {userData ? 'Update user account details' : 'Create new user account'}
                                </p>
                            </div>
                        </div>
                        <button
                            type="button"
                            onClick={toggle}
                            disabled={loading}
                            className="btn-close-custom"
                            style={{
                                background: 'rgba(255,255,255,0.2)',
                                border: 'none',
                                borderRadius: '50%',
                                width: '36px',
                                height: '36px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: loading ? 'not-allowed' : 'pointer',
                                transition: 'all 0.3s ease',
                                opacity: loading ? 0.5 : 1
                            }}
                            onMouseEnter={(e) => {
                                if (!loading) {
                                    e.currentTarget.style.background = 'rgba(255,255,255,0.3)';
                                    e.currentTarget.style.transform = 'rotate(90deg)';
                                }
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.background = 'rgba(255,255,255,0.2)';
                                e.currentTarget.style.transform = 'rotate(0deg)';
                            }}
                        >
                            <CloseIcon style={{ color: '#fff', fontSize: '20px' }} />
                        </button>
                    </div>
                </div>

                {/* Modal Body */}
                <ModalBody className="p-0" style={{ background: '#f8f9fa' }}>
                    {loading && (
                        <div
                            className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center"
                            style={{
                                background: 'rgba(255,255,255,0.9)',
                                zIndex: 1050,
                                backdropFilter: 'blur(4px)'
                            }}
                        >
                            <div className="text-center">
                                <CircularProgress size={50} style={{ color: '#667eea' }} />
                                <p className="mt-3 text-muted fw-bold">Processing...</p>
                            </div>
                        </div>
                    )}

                    <div style={{ maxHeight: 'calc(90vh - 120px)', overflowY: 'auto' }}>
                        {userData ? (
                            <AccountCreation title="User Details" onSubmit={handleSubmit} userData={userData} status={userData.active} />
                        ) : (
                            <AccountCreation title="User Details" onSubmit={handleSubmit} />
                        )}
                    </div>
                </ModalBody>
            </Modal>
        </div>
    );
};

ModalUserCreationForm.propTypes = {
    title: PropTypes.string,
    message: PropTypes.string,
    color: PropTypes.string.isRequired,
    header: PropTypes.bool,
};

ModalUserCreationForm.defaultProps = {
    title: "",
    message: "",
    colored: false,
    header: false,
};

export default connect((state) => ({
    rtl: state.rtl,
}))(ModalUserCreationForm);
